module.exports = __webpack_public_path__ + "img/ic_aksesditolak.a95b2b98.svg";